const zero24 = '000000000000000000000000'

interface Test {
    testId?: string,
    name: string,
    scheduleDate: string,
    scheduleEndDate?: string,
    maxAttempt: string,
    duration: string,
    syllabus: string,
    blockRevisionTime: string,
    type: string
}

interface Week {
    content: Test[]
}

interface Phase {
    milestoneTests: Test[],
    weeks: Week[],
    extraTests: Test[]
}

interface milestoneTestDuplicateData {
    importedTest: string,
    duplicateTestInfo: {
        phase: number
    }
}

interface mainTestDuplicateData {
    importedTest: string,
    duplicateTestInfo: {
        phase: number,
        week: number
    }
}

const checkIfTestsAreDuplicate = (test1: Test, test2: Test) => {
    let isTestDuplicate = false;
    
    if ((test1.testId && test1.testId !== zero24) && (test2.testId && test2.testId !== zero24)){
        
        if(test1.testId === test2.testId){
            isTestDuplicate = true
            return isTestDuplicate;
        }
    } else {
        // const nameCheck = test1.name.toLowerCase().trim() === test2.name.toLowerCase().trim();
        // const startDateCheck = test1.scheduleDate.toLowerCase().trim() === test2.scheduleDate.toLowerCase().trim();
        // const endDateCheck = test1.scheduleEndDate && test2.scheduleEndDate ? 
        //                     (test1.scheduleEndDate.toLowerCase().trim() === test2.scheduleEndDate.toLowerCase().trim()) :
        //                      true ;
        // const maxAttemptCheck = +test1.maxAttempt === +test2.maxAttempt;
        // const durationCheck = +test1.duration === +test2.duration;
        // const syllabusCheck = test1.syllabus.toLowerCase().trim() === test2.syllabus.toLowerCase().trim();
        // const revisionCheck = +test1.blockRevisionTime === +test2.blockRevisionTime;
        // const typeCheck = test1.type.toLowerCase().trim() === test2.type.toLowerCase().trim();

        // isTestDuplicate = (nameCheck && startDateCheck && endDateCheck && syllabusCheck && typeCheck)
        return isTestDuplicate;
    }

}


export const checkForDuplicateTests = (phases : Phase[], testData : Test[]) => {
    

    let duplicateTestData : {
        milestoneTests: milestoneTestDuplicateData[],
        mainTests: mainTestDuplicateData[],
        extraTests: milestoneTestDuplicateData[]
    } = {
        milestoneTests : [], // { importedTest: testId , duplicateTestInfo:  {Phase #} }
        mainTests : [], // { importedTest: testId , duplicateTestInfo: { Phase #, Week # } }
        extraTests: [] // { importedTest: testId , duplicateTestInfo:  {Phase #} }
    }

    testData.forEach((test: Test) => {
        phases.forEach(( phase : Phase, phaseIndex : number) => {
            const { milestoneTests, weeks, extraTests = [] } = phase;
            milestoneTests.forEach((milestoneTest:Test, milestoneIndex:number) => {
                const isMilestoneTestDuplicate = checkIfTestsAreDuplicate(test, milestoneTest)
                if(isMilestoneTestDuplicate){
                    // Do something...
                    let updatedMilestoneTests = [...duplicateTestData.milestoneTests];
                    const duplicateData = {
                        importedTest: test.testId && test.testId !== zero24 ? test.testId : test.name, 
                        duplicateTestInfo: {
                            phase: phaseIndex
                        }
                    }
                    updatedMilestoneTests = [...updatedMilestoneTests, duplicateData];
                    duplicateTestData.milestoneTests = updatedMilestoneTests;
                }
            })

            weeks.forEach((week: any, weekIndex: number) => {
                const { content : mainTests } = week;
                mainTests.forEach((mainTest:any, mainTestIndex: number) => {
                    const isMainTestDuplicate = checkIfTestsAreDuplicate(test, mainTest)
                    if(isMainTestDuplicate){
                        // Do something...
                        let updatedMainTests = [...duplicateTestData.mainTests];
                        const duplicateData = {
                            importedTest: test.testId && test.testId !== zero24 ? test.testId : test.name, 
                            duplicateTestInfo: {
                                phase: phaseIndex,
                                week: weekIndex
                            }
                        }
                        updatedMainTests = [...updatedMainTests, duplicateData];
                        duplicateTestData.mainTests = updatedMainTests;
                    }
                })
            })

            extraTests.forEach((extraTest:Test, extraTestIndex:number) => {
                const isExtraTestDuplicate = checkIfTestsAreDuplicate(test, extraTest)
                if(isExtraTestDuplicate){
                    // Do something...
                    let updatedExtraTests = [...duplicateTestData.extraTests];
                    const duplicateData = {
                        importedTest: test.testId && test.testId !== zero24 ? test.testId : test.name, 
                        duplicateTestInfo: {
                            phase: phaseIndex
                        }
                    }
                    updatedExtraTests = [...updatedExtraTests, duplicateData];
                    duplicateTestData.extraTests = updatedExtraTests;
                }
            })

        })
    })

    
    return {
        duplicateExists: (duplicateTestData.milestoneTests.length > 0) || (duplicateTestData.mainTests.length > 0),
        duplicateTestData : duplicateTestData
    }
}


export const checkForDuplicateTestsWithinSheet = (testData : Test[]) => {
    const testIds = testData
                    .map((test:any) => {
                        if(test.testId === "000000000000000000000000") return;
                        return test.testId;
                    })
                    .filter((testId) => testId !== undefined);
    const testIdsSet = Array.from(new Set(testIds));
    
    if(testIdsSet.length < testIds.length){
        return true
    } else {
        return false
    }

}

// let duplicateTestData : {
//     milestoneTests: milestoneTestDuplicateData[],
//     mainTests: mainTestDuplicateData[]
// } = {
//     milestoneTests : [], // { importedTest: testId , duplicateTestInfo:  {Phase #} }
//     mainTests : [] // { importedTest: testId , duplicateTestInfo: { Phase #, Week # } }
// }

export const checkIfTestIdAlreadyMappedInPlan = (phases: Phase[], testId: string) => {
    let isTestIdAlreadyMapped = false;
    phases.forEach(( phase : Phase, phaseIndex : number) => {
        const { milestoneTests, extraTests,  weeks } = phase;

        milestoneTests.forEach((milestoneTest:Test, milestoneIndex:number) => {
            if(milestoneTest.testId === testId){
                isTestIdAlreadyMapped = true;
            }
        })
        extraTests.forEach((extraTest:Test, index:number) => {
            if(extraTest.testId === testId){
                isTestIdAlreadyMapped = true;
            }
        })
        
        weeks.forEach((week: any, weekIndex: number) => {
            const { content : mainTests } = week;
            mainTests.forEach((mainTest:any, mainTestIndex: number) => {
                if(mainTest.testId === testId){
                    isTestIdAlreadyMapped = true;
                }
            })
        })

    })

    return isTestIdAlreadyMapped;
}

export const checkIfTestWithinCourseDuration = ({
    testStart,
    testEnd,
    courseStart,
    courseEnd
}: {
    testStart : string,
    testEnd : string,
    courseStart : string,
    courseEnd: string
}) => {
    const testStartDate = new Date(testStart);
    const testEndDate = new Date(testEnd);

    const courseStartDate = new Date(courseStart);
    const courseEndDate = new Date(courseEnd);

    const isTestStartGreaterThanCourseStart = testStartDate > courseStartDate;
    const isTestEndLessThanCourseEnd = testEndDate < courseEndDate;

    const isTestWithinCourse = isTestStartGreaterThanCourseStart && isTestEndLessThanCourseEnd;

    return isTestWithinCourse;
}

export const checkQuestionsCountInAllTests = () => {
    
}

// TODO: Use above functions while adding a new test: uploading, adding via add test etc 
export const checkIfTestAlreadyAddedInTestSeries = (tests: any, test: any) => {
    let isTestAlreadyAdded = false;
    
    const { testId: testIdToCheck} = test;
    tests.forEach((test:any) => {
        const { testId } = test;
        if (testIdToCheck !== zero24 && testIdToCheck === testId){
            isTestAlreadyAdded = true;
            return isTestAlreadyAdded;
        }
    })
    
    return isTestAlreadyAdded;
}